import { render, staticRenderFns } from "./ProcessedImportDetail.vue?vue&type=template&id=34e0d9fa&"
import script from "./ProcessedImportDetail.vue?vue&type=script&lang=js&"
export * from "./ProcessedImportDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports